export default {
  title: '防偽管理',
  qrCodeList: '二維碼列表',
  scanRecords: '掃碼記錄',
};
